import { render, staticRenderFns } from "./ModuleSubs.vue?vue&type=template&id=5d8136d5&scoped=true&"
import script from "./ModuleSubs.vue?vue&type=script&lang=js&"
export * from "./ModuleSubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8136d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
